module.exports = __webpack_public_path__ + "img/MINIPROGRAM.d122ec80.svg";